import "../../css/Pulse.css";

function Pulse() {
  return <div className="dot-pulse"></div>;
}

export default Pulse;
